import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { getDataSession } from 'views/Utils/Common';
import { Link } from 'react-router-dom';
import ListTable from 'components/table/ListTable';
import RenderButtons from 'components/table/RenderButtons';
import { useUIUtils } from 'hooks/useUIUtils';

const List = ({ history, match }) => {
    const { path } = match;
    const { t } = useTranslation("common");
    const { changeGlobalTitle } = useUIUtils()

    const columns = [
        { renderCell: RenderButtons, type: 'actions', headerName: '', maxWidth: 20, path: path, opciones: "editar" },
        { field: 'nombre', headerName: 'Nombre' },
        { field: 'fecha_Registro', headerName: 'Fecha Registro'},
        { field: 'tipo', headerName: 'Tipo',  renderCell:
             ({ value }) => {
                switch(value)
                {
                    case "I":
                       return "Inefectiva"
                    case "E":
                        return "Efectiva"
                    default:
                        return null
                }
             }},
    ];

    useEffect(() => changeGlobalTitle('Razon de Visita', 'Listado de Razones de Visitas'), [changeGlobalTitle]);

    return (
        <>
            <div className='espacio10px' />
            <div className='container-fluid'>
            <div className='col-12 col-sm-12 col-md-12 row'>
                    <div className='col-sm-2'>
                        <Link to={`${path}/add`} className='btn btn-outline-primary m-1' style={{ width: 'auto' }}>
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='18'
                                height='18'
                                fill='currentColor'
                                className='bi bi-plus-square'
                                viewBox='0 0 16 16'
                            >
                                <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                                <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                            </svg>
                            &nbsp; {t('app.SwalFire.nuevo')}
                        </Link>
                    </div>
                    </div>
                <div className='col-md-12'>
                    <ListTable 
                        columns={columns} 
                        path={path} 
                        url={`VxRazonVist/GetList?sucursal_Id=${getDataSession('sucursal')}`} />
                </div>
            </div>
        </>
    );
}

export { List };